import React, { useRef, useState } from 'react';
import { cn } from '../../../lib/utils';
import { Button, Label } from '../../../components/ui';

export function TicketingAttachmentsInput({ id, label = 'Attachments', files, onChange, theme }) {
  const inputRef = useRef(null);
  const [dragOver, setDragOver] = useState(false);

  const appendFiles = (incoming) => {
    const list = Array.from(incoming || []);
    if (list.length === 0) return;
    const current = Array.isArray(files) ? files : [];
    onChange([...current, ...list]);
  };

  const removeFileAt = (index) => {
    const current = Array.isArray(files) ? files : [];
    onChange(current.filter((_, i) => i !== index));
  };

  const openPicker = () => inputRef.current?.click();

  return (
    <section>
      <Label htmlFor={id} className="mb-2 block font-semibold">
        {label}
      </Label>
      <input
        id={id}
        ref={inputRef}
        type="file"
        multiple
        className="hidden"
        onChange={(e) => {
          appendFiles(e.target.files);
          e.target.value = '';
        }}
      />
      <div
        className={cn(
          'rounded-xl border-2 border-dashed px-4 py-5 text-center transition-colors',
          dragOver
            ? 'border-blue-500 bg-blue-50/80 dark:border-blue-400 dark:bg-blue-950/30'
            : 'border-slate-300 dark:border-slate-700 bg-slate-50/60 dark:bg-slate-900/30',
        )}
        onDragOver={(e) => {
          e.preventDefault();
          setDragOver(true);
        }}
        onDragLeave={(e) => {
          e.preventDefault();
          setDragOver(false);
        }}
        onDrop={(e) => {
          e.preventDefault();
          setDragOver(false);
          appendFiles(e.dataTransfer?.files);
        }}
      >
        <p className={cn('m-0 text-sm', theme?.text?.secondary || 'text-slate-600 dark:text-slate-300')}>
          Drag and drop files here, or click below.
        </p>
        <Button type="button" variant="outline" size="sm" className="mt-3" onClick={openPicker}>
          Select files
        </Button>
      </div>
      <p className={cn('text-xs mt-2', theme?.text?.muted || 'text-slate-500 dark:text-slate-400')}>
        Optional. Files are uploaded after the ticket is created.
      </p>
      {Array.isArray(files) && files.length > 0 ? (
        <div className="mt-2 space-y-1.5">
          <p className={cn('text-xs', theme?.text?.muted || 'text-slate-500 dark:text-slate-400')}>
            {files.length} file(s) selected
          </p>
          <ul className="list-none p-0 m-0 space-y-1">
            {files.map((file, idx) => (
              <li key={`${file?.name || 'file'}-${idx}`} className="flex items-center justify-between gap-2 text-xs">
                <span className="truncate">{file?.name || `File ${idx + 1}`}</span>
                <Button
                  type="button"
                  variant="ghost"
                  size="sm"
                  className="h-6 px-2"
                  onClick={() => removeFileAt(idx)}
                >
                  Remove
                </Button>
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </section>
  );
}

export default TicketingAttachmentsInput;
